import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { processInfoProperty } from './process-info-property';

export const processInfo = z
  .object({
    designUuid: z.string().nullable().optional().describe('Design UUID'),

    name: z.string().nullable().optional().describe('The process name'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .describe('Human-readable label'),

    description: z.string().nullable().optional().describe('Description'),

    processInfoProperties: z
      .array(processInfoProperty)
      .nullable()
      .optional()
      .describe("The process's declared properties"),
  })
  .describe(
    'Summary information about a process design for the called process dropdown, with the declared properties a call activity maps into and reads back from the child instance.',
  )
  .as('ProcessInfo', { embedded: true });

export { processInfo as processInfoSchema };
